import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import FusionCharts from "fusioncharts";

import FusionChart from "../Graphs/FusionChart";
import SalesTable from "./SalesTable";
import { useDispatch } from "react-redux";
import { graphData } from "../../store/actions";

const Sales = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  // const schemaFetch = fetch(
  //   "https://s3.eu-central-1.amazonaws.com/fusion.store/ft/schema/disabling-time-navigator-schema.json"
  // ).then(jsonify);

  const dataSource = {
    navigator: {
      enabled: 0,
    },
    caption: {
      text: id.replace(/-/g, " "),
    },
    yaxis: [
      {
        plot: {
          value: id.replace(/-/g, " "),
          connectnulldata: true,
          style: {
            "plot.null": {
              "stroke-dasharray": "none",
              // stroke: "#FF0000",
            },
          },
        },
        plottype: "line",
        title: "Price",
        format: {
          prefix: "$",
        },
      },
    ],
  };

  const [timeseriesDs, settimeseriesDs] = useState({
    type: "timeseries",
    renderAt: "container",
    width: "100%",
    height: "300",
    dataSource,
  });

  function onFetchData() {
    Promise.all([
      dispatch(graphData()),
      [
        {
          name: "Time",
          type: "date",
          format: "%d-%b-%y",
        },
        {
          name: "Footfall",
          type: "number",
        },
      ],
    ]).then((res) => {
      const data = res[0];

      const schema = res[1];

      const fusionTable = new FusionCharts.DataStore().createDataTable(data, [
        {
          name: "Time",
          type: "date",
          format: "%d-%b-%y",
        },
        {
          name: id.replace(/-/g, " "),
          type: "number",
        },
      ]);
      const timeseriesDss = Object.assign({}, timeseriesDs);
      timeseriesDss.dataSource.data = fusionTable;
      settimeseriesDs(timeseriesDss);
    });
  }

  useEffect(() => {
    onFetchData();
  }, []);

  return (
    <>
      <div className="chart-box bg-white">
        <div className="d-flex justify-content-between align-items-center">
          <h3>Sales volume data</h3>
          <div className="right-side d-flex align-items-center">
            <span className="full-screen">
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M2.85714 12.8571H0V20H7.14286V17.1429H2.85714V12.8571ZM0 7.14286H2.85714V2.85714H7.14286V0H0V7.14286ZM17.1429 17.1429H12.8571V20H20V12.8571H17.1429V17.1429ZM12.8571 0V2.85714H17.1429V7.14286H20V0H12.8571Z"
                  fill="#4A4A4A"
                ></path>
              </svg>
            </span>
            <div className="select-bar ml-4">
              <select className="form-control">
                <option value="">All Time</option>
                <option value="">6 hour</option>
                <option value="">12 hour</option>
                <option value="">24 hour</option>
              </select>
            </div>
            <div className="select-bar ml-4">
              <select className="form-control">
                <option value="">Download</option>
                <option value="">Download</option>
                <option value="">Download</option>
                <option value="">Download</option>
              </select>
            </div>
          </div>
        </div>
        <div className="main-chart">
          <FusionChart
            dataSource={dataSource}
            height={300}
            width={"100%"}
            timeseriesDs={timeseriesDs}
          />
          {/* <img className="img-fluid" src="/img/sales-volume-img.png" alt="" /> */}
        </div>
      </div>
      <SalesTable CollectionName={id} />
    </>
  );
};

export default Sales;
